// import '@babel/polyfill'
import BEXT from './src';
import KNBAdapter from './src/adapter/knb';

const bext = new BEXT();
if (window) {
  window.BExt = bext;
  window.bext = bext;
}

export default bext;
export const KNBAdapterWrap = KNBAdapter;
